export default {
    TITLE: "Участники",
    YOU: "Вы",
    USER_DELETED: "Удалён",
    ADD_USER_ACCESS: "Добавить участника",
    EDIT_USER_ACCESS: "Редактировать доступ"
};
